import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { Storage } from '@dvs-angular/storage';

import { tokenServiceFactory } from './token-service.factory';
import { TokenService } from './token.service';
import { TokenRepository } from './token.repository';
import { AuthHttpClient } from './auth-http-client.service';
import { ConfigService } from './config.service';

@NgModule({
  imports: [
    HttpClientModule
  ],
  providers: [
    AuthHttpClient,
    TokenRepository,
    ConfigService,
    {
      provide: TokenService,
      useFactory: tokenServiceFactory,
      deps: [
        Storage,
        TokenRepository,
        ConfigService
      ]
    }
  ],
  declarations: []
})
export class AuthHttpClientModule { }
